var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('v-main',[(_vm.showNav)?_c('Toolbar'):_vm._e(),_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }